import type { ReactNode } from 'react';

export const symbol_uppercase: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M682.5-248.5Q674-257 674-270v-256l-53 53q-9 9-21 9t-21-9q-9-9-9-21t9-21l104-104q9-9 21-9t21 9l104 104q9 9 9 21t-9 21q-9 9-21 9t-21-9l-53-53v256q0 13-8.5 21.5T704-240q-13 0-21.5-8.5ZM254-361l-37 105q-2 7-8.5 11.5T194-240q-13 0-20-10t-2-22l143-392q3-8 9-12t14-4h19q8 0 14 4t9 12l144 392q5 12-2.5 22T501-240q-8 0-14.5-4t-8.5-12l-37-105H254Zm16-44h155l-77-217h-2l-76 217Z"
		/>
	</svg>
);
